import { render, staticRenderFns } from "./ModuleDappsCenter.vue?vue&type=template&id=146f13d7"
import script from "./ModuleDappsCenter.vue?vue&type=script&lang=js"
export * from "./ModuleDappsCenter.vue?vue&type=script&lang=js"
import style0 from "./ModuleDappsCenter.vue?vue&type=style&index=0&id=146f13d7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports